// extracted by mini-css-extract-plugin
export default {"applayout":"Layout_applayout__S0J4j","container":"Layout_container__QNNhQ","wideContainer":"Layout_wideContainer__YT37i","midContainer":"Layout_midContainer__v6WpJ"};